export default __webpack_public_path__ + "static/media/vega-gb-logo.f30315dc.png";